import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useSelector } from "react-redux";
import { userRequest } from "../request";

const DepartmentChart = () => {
  const user = useSelector((state) => state.user.user);
  const [chartData, setChartData] = useState(null);

  const fetchChartData = async () => {
    try {
      const response = await userRequest(user.token).get(
        "/stats/department-stats"
      );
      setChartData(response.data);
    } catch (error) {
      console.error("Error fetching department stats:", error);
    }
  };

  useEffect(() => {
    fetchChartData();
  }, [user.token]);

  if (!chartData) {
    return <div>Loading...</div>;
  }

  // Mapping of department names to abbreviations
  const departmentAbbreviations = {
    Quality: "QLT",
    Finance: "FIN",
    Stores: "STO",
    Strategy: "STR",
    Maintenance: "MNT",
  };

  // Transform department names to their abbreviations
  const categories = chartData.map(
    (dept) => departmentAbbreviations[dept._id] || dept._id
  );

  // Calculate the percentage of closed projects
  const closedPercentage = chartData.map(
    (dept) =>
      ((dept.closedProjects / dept.totalProjects) * 100).toFixed(2) + "%"
  );

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Department-wise Total Vs Closed",
    },
    xAxis: {
      categories: categories,

      labels: {
        formatter: function () {
          return `${this.value}<br/>(${closedPercentage[this.pos]})`;
        },
      },
    },
    yAxis: {
      min: 0,
    },
    series: [
      {
        name: "Total Projects",
        data: chartData.map((dept) => dept.totalProjects),
        color: "#32CD32",
      },
      {
        name: "Closed Projects",
        data: chartData.map((dept) => dept.closedProjects),
        color: "#0071c5",
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
           
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
            xAxis: {
              labels: {
                rotation: 0,
                style: {
                  fontSize: "10px",
                },
              },
            },
          },
        },
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
            xAxis: {
              labels: {
                rotation: 0,
                style: {
                  fontSize: "12px",
                },
              },
            },
          },
        },
        {
          condition: {
            minWidth: 769,
          },
          chartOptions: {
            
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "middle",
            },
          },
        },
      ],
    },
  };

  return (
    <div className=" w-screen lg:w-min overflow-auto shadow-lg rounded-2xl border z-10 ">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default DepartmentChart;
